<template>
  <div v-if="has_contest_store">
    <div class="match-info-head-wrap">
      <h1 itemprop="headline" class="head-title">{{ generateHeadline() }}</h1>
      <p>{{ generateDesc() }}</p>
    </div>
    <gamezy-ad size="mob_small" ad_id="mob_small-ad-1" :autoDetect="true" />
    <gamezy-ad size="web_small" ad_id="web_small-ad-1" :autoDetect="true" />
    <range-slider></range-slider>
    <roi-list-page
      :selected_match_contests="selectedMatchContests"
      :checkIfTourIsActive="checkIfTourIsActive"
      ref="contest-list"
    />
    <no-list
      :translations="translations"
      :toShow="'no_matches'"
      v-show="no_matches_active"
    />
  </div>
</template>
<script>
import contestStore from "../../../store/modules/matchDetails/contestStore";
import {
  getMatch,
  _mc_canStartPolling,
  _mc_getPollingPriority,
  getMatchInfoTitle,
  cssImport,
} from "../../../assets/js/common";
import rangeSlider from "./RangeSlider";
import roiListPage from "./ROIListPage";
import NoList from "../../common/NoList";
import GamezyAd from "../../common/GamezyAd";

export default {
  data() {
    return {
      componentPromises: null,
      checkMatchUpdatesTimer: null,
      polling_priority: null,
    };
  },
  components: {
    rangeSlider,
    roiListPage,
    NoList,
    GamezyAd
  },
  computed: {
    has_contest_store() {
      return !!(this.$store.state && this.$store.state.contest_store && this.$store.state.contest_store.contest_store_filled);
    },
    is_matches_loaded() {
      return this.$store.state.match_detail_store.isMatchesLoaded;
    },
    match_data() {
      return this.$store.state.match_detail_store.match_data;
    },
    slug: {
      get: function () {
        return this.$store.state.match_detail_store.slug;
      },
      set: function (new_slug) {
        this.$store.state.match_detail_store.slug = new_slug;
      },
    },
    in_match_categories() {
      return this.$store.state.match_detail_store.in_match_categories;
    },
    current_match() {
      return getMatch(this.match_data, "slug", this.slug);
    },
    is_pre_match() {
      let curr_match = this.current_match;
      return !!(curr_match && curr_match.status === 1);
    },
    no_matches_active() {
      return this.$store.state.match_detail_store.no_matches_active;
    },
    is_custom_client() {
      return this.$store.state.is_custom_client;
    },
    translations() {
      return this.$store.state.translations;
    },
    /**shared state end */
    selectedMatchContests() {
      return this.$store.state.contest_store.selectedMatchContests;
    },
    reset_scroll() {
      if (this.$store.state && this.$store.state.contest_store) {
        return this.$store.state.contest_store.reset_scroll;
      } else {
        return false; // default value in store
      }
    },
    is_polling: {
      get: function () {
        return this.$store.state.contest_store.is_polling;
      },
      set: function (val) {
        this.$store.state.contest_store.is_polling = val;
      },
    },
    can_update: {
      get: function () {
        return this.$store.state.contest_store.can_update;
      },
      set: function (val) {
        this.$store.state.contest_store.can_update = val;
      },
    },
  },
  async serverPrefetch() {
    // serverPrefetch runs only on serverside
    this.$store.registerModule("contest_store", contestStore);
    return await this.$store.dispatch("contest_store/fetchROIdata", {
      slug: this.$store.state.match_detail_store.slug,
    });
  },
  beforeMount() {
    this.registerModule();
  },
  mounted() {
    let hasStore = this.has_contest_store;
    if(!hasStore){
      cssImport(["/static-assets/css/menu-card.css"])
    }
    this.callApis();
    setTimeout(() => {
      this.$emit('cssLoaded', true);
    }, 500)
  },
  methods: {
    registerModule() {
      let hasComponentModule = this.$store.hasModule("contest_store");
      if (!hasComponentModule) {
        this.$store.registerModule("contest_store", contestStore, {
          preserveState: this.has_contest_store,
        });
      }
    },
    callApis() {
      this.componentPromises = this.initApis();
      this.componentPromises.then(() => {
        if (this.current_match) {
          this.startMatchPolling();
        }
      });
    },
    async initApis() {
      return await this.$store.dispatch("contest_store/fetchROIdata", {
        slug: this.$store.state.match_detail_store.slug,
      });
    },
    generateHeadline() {
      return getMatchInfoTitle(this.current_match, this.translations.contests_headline);
    },
    generateDesc() {
      return getMatchInfoTitle(this.current_match, this.translations.contests_headline, false, false, true);
    },
    scrollToContestListing() {
      let list = document.querySelector(".contest-list");
      list && list.scrollTo(0, 0);
    },
    checkIfTourIsActive() {
      return this.$store.state.isTourActive;
    },
    loadUpdatedContestList() {
      this.$store.dispatch("contest_store/fetchROIdata", {
        slug: this.slug,
      });
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      this.$store.dispatch("contest_store/resetPushUpdate");
    },
    eventChangeHandler() {
      this.is_polling = false;
      clearInterval(this.checkMatchUpdatesTimer);
      this.startMatchPolling();
      try {
        this.$refs["contest-list"].resetFilter();
        /*eslint-disable no-empty*/
      } catch (e) {}
    },
    startMatchPolling() {
      if (this.no_matches_active) {
        clearInterval(this.checkMatchUpdatesTimer);
        return;
      }
      if (this.is_polling) return;

      if (this.checkMatchUpdatesTimer)
        clearInterval(this.checkMatchUpdatesTimer);

      if (_mc_canStartPolling(this.current_match)) {
        this.polling_priority = _mc_getPollingPriority(
            this.current_match
        );
        this.is_polling = true;
        this.startInterval();
      }
    },
    startInterval() {
      this.checkMatchUpdatesTimer = setInterval(() => {
        if (!_mc_canStartPolling(this.current_match)) {
          this.is_polling = false;
          clearInterval(this.checkMatchUpdatesTimer);
          return;
        }

        let checkPriority = _mc_getPollingPriority(this.current_match);

        if (this.polling_priority.ref !== checkPriority.ref) {
          this.is_polling = false;
          return this.startMatchPolling();
        }
        this.can_update = true;
        this.$store.dispatch("contest_store/matchDataUpdatePolling");
      }, this.polling_priority.interval);
    },
  },
  beforeDestroy() {
    // reset contest data
    this.$store.unregisterModule("contest_store");
  },
  unmounted() {
    this.is_polling = false;
    clearInterval(this.checkMatchUpdatesTimer);
    this.checkMatchUpdatesTimer = null;
    this.$store.dispatch("contest_store/resetPushUpdate");
    clearInterval(this.checkForAllowCookieInterval);
    if (this.componentPromises) {
      this.componentPromises.then(() => {
        this.$store.unregisterModule('contest_store');
      });
    } else {
      this.$store.unregisterModule('contest_store');
    }
  },
};
</script>
